import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../../style/AppPages.css";
import "../../style/Register.css";
import "../../style/FormStyles.css";
import { createAccount } from "../../controllers/AccountConnectionLayer";
import { useTranslation } from 'react-i18next';

const RegisterPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        email: "",
        password: "",
        confirmPassword: "",
    });

    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        // Validate password match when updating confirmPassword
        if (name === "confirmPassword" || name === "password") {
            setPasswordMatchError(
                name === "confirmPassword" && value !== formData.password
            );
        }
    };

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword((prev) => !prev);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setPasswordMatchError(true);
            return;
        }

        try {
            await createAccount({ email: formData.email, password: formData.password });
            navigate("/account/success");
        } catch (error) {
            alert(t("account.passwordFailureMessage"));
        }
    };

    return (
        <div className="page-padding">
            <div className="register-container">
                <h1 className='title-login'>Create an account</h1>
                <form onSubmit={handleSubmit} className="form-fields login-section">
                    <input
                        type="email"
                        name="email"
                        placeholder={t("account.emailLabel")}
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />

                    <div className="password-field">
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder={t("account.passwordLabel")}
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                        />
                        <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                            className="eye-icon"
                            onClick={togglePasswordVisibility}
                        />
                    </div>

                    <div className="password-field">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            placeholder={t("account.confirmPasswordLabel")}
                            value={formData.confirmPassword}
                            onChange={handleInputChange}
                            required
                        />
                        <FontAwesomeIcon
                            icon={showConfirmPassword ? faEyeSlash : faEye}
                            className="eye-icon"
                            onClick={toggleConfirmPasswordVisibility}
                        />
                    </div>

                    {passwordMatchError && (
                        <p className="error-message">{t("account.passwordErrorMessage")}</p>
                    )}

                    <button type="submit" disabled={passwordMatchError}>
                        {t("account.submitLabel")}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default RegisterPage;
